import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { contentContext } from "../../context/contentContext";


const Sidebar = () => {
    const location = useLocation();
    let { id } = useParams();
    const navigate = useNavigate();
    const { pathname } = location;
    const [userType, setUserType] = useState(localStorage.getItem("userType"))

    const { setShowPopup, setSelectedOptions, menuActive, setUserSearch, menuLearningActive, setMenuLearning, menuSettingsActive, setMenuSettings, setMenuState, setMultiSelectFields, setActiveFieldsObj, setActiveMenuObj,
        setSelectedOptionsClientName, setSearchPayload, setInitialCategoriesData1, toggleMenu, setToggleMenu, GetTimeActivity, userData, setUserData } = useContext(contentContext)
    const [activeMenuPath, setActiveMenuPath] = useState(location.pathname);
    // const isActive = (path) => activeMenuPath === path ? 'active' : '';


    const isActive = (path, menuKey) => {
        // Get saved menu from sessionStorage
        const fromMenu = sessionStorage.getItem("fromMenu");
        console.log("menuKey:", menuKey)
        console.log("path:", path)
        // Exact route match
        if (location.pathname === path) return "active";

        // On result page, check if menuKey matches
        if (location.pathname.startsWith("/result/") && fromMenu === menuKey) {
            return "active";
        }
        //   else if(location.pathname.startsWith("/history/") && fromMenu === menuKey){
        //     return "active";
        //   }

        return "";
    };
    const menuItems = [
        { path: '/modules', label: 'Modules' },
        { path: '/cases', label: 'Cases' },
        { path: '/admin-quiz', label: 'Quiz' },
        { path: '/lecturelibrary', label: 'Video Library' },
        { path: '/cpcmanagement', label: 'CPC Management' }
    ];
    // useEffect(() => {
    //     if (pathname.includes("dashboard")) {
    //         setIsActive("dashboard");
    //     } else if (pathname.includes("answers")) {
    //         setIsActive("answers");
    //     } else if (pathname.includes("reports")) {
    //         setIsActive("reports");
    //     }
    // }, [pathname]);
    // useEffect(() => {
    //     const path = pathname.split("/")[1]; // grabs 'dashboard' from '/dashboard'
    //     setIsActive(path);

    //     if (["tests", "biopsytypes"].includes(path)) {
    //         setMenuState(true)

    //     }
    //     if (["cases","Adminquiz","lecturelibrary","cpcmanagement"].includes(path)) {
    //         setMenuLearning(true)

    //     }

    // }, [pathname]);


    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("ClientName");
        localStorage.removeItem("ClientType");
        navigate("/");
    };

    const handleMenuClick = (path, menuKey) => {
        setUserSearch('')
        sessionStorage.setItem("fromMenu", menuKey);
        if (path === "/dashboard" || path === "/users" || path == "/registeredusers" || path === "/subscription" || path === "/fellowshiplist" || path === "/transctions") {
            setMenuLearning(false)
            setMenuState(false)
            setMenuSettings(false)
        }
        setActiveMenuPath(path);
        setToggleMenu(false);
        navigate(path);
        // setTimeout(() => {
        //     if (value === "dashboard") {
        //         navigate("/dashboard");
        //     } else if (value === "answers") {
        //         navigate("/answers");
        //     } else if (value === "reports") {
        //         navigate("/reports");
        //     }
        // }, 0);
    };

    // console.log('toggleMenu ', toggleMenu)



    return (
        <div className={toggleMenu ? `quiz-page-side vertical-menu menu-show` : `quiz-page-side vertical-menu`}>
            <div data-simplebar className="h-100">
                <div id="sidebar-menu">

                    {userType?.toLowerCase() === 'admin' ?
                        <ul className="metismenu list-unstyled" id="side-menu">
                            <li onClick={() => handleMenuClick("/dashboard")}>
                                <a className={`waves-effect ${isActive('/dashboard')}`}>
                                    <i className="material-symbols-outlined">grid_view</i>
                                    <span>Biopsy</span>
                                </a>
                            </li>
                            <li>
                                <a onClick={(e) => {
                                    setMenuLearning(!menuLearningActive);
                                    setMenuState(false);
                                    setMenuSettings(false);
                                }} className="has-arrow waves-effect">
                                    {/* <i className="material-symbols-outlined"> quick_reference_all</i> */}
                                    <i className="material-symbols-outlined"> library_books</i>
                                    <span key="t-chat">Learning Hub</span>
                                </a>
                                <ul className={menuLearningActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                    {/* <li onClick={() => handleMenuClick("/modules")} className={`waves-effect ${isActive('/modules')}`}><a key="t-tui-calendar">Modules</a></li> */}
                                    <li onClick={() => handleMenuClick("/cases")} className={`waves-effect ${isActive('/cases') || isActive('/editcase/' + id) || isActive('/viewcase/' + id)}`}><a key="t-tui-calendar">Cases</a></li>
                                    {/* <li onClick={() => handleMenuClick("/Adminquiz")} className={`waves-effect ${isActive('/Adminquiz')}`}><a key="t-tui-calendar">Quiz</a></li> */}
                                    <li onClick={() => handleMenuClick("/lecturelibrary")} className={`waves-effect ${isActive('/lecturelibrary') || isActive("/viewlecturelibrary/" + id) || isActive("/editlecturelibrary/" + id)}`}><a key="t-full-calendar">Video Library</a></li>
                                    <li onClick={() => handleMenuClick("/modules")} className={`waves-effect ${isActive('/modules')}`}><a key="t-tui-calendar">Modules</a></li>

                                    {/* <li onClick={() => handleMenuClick("/admin-quiz")} className={`waves-effect ${isActive('/Adminquiz')}`}><a key="t-tui-calendar">Quiz</a></li> */}
                                    <li onClick={() => handleMenuClick("/cpcmanagement")} className={`waves-effect ${isActive('/cpcmanagement')}`}><a key="t-full-calendar">CPC Management</a></li>
                                    <li onClick={() => handleMenuClick("/bulkimageupload")} className={`waves-effect ${isActive('/bulkimageupload')}`}><a key="t-bulk-upload">Bulk Image Upload</a></li>

                                </ul>
                            </li>
                            <li>
                                <a onClick={(e) => {
                                    setMenuLearning(false);
                                    setMenuState(!menuActive);
                                    setMenuSettings(false);
                                }} className="has-arrow waves-effect">
                                    <i className="material-symbols-outlined"> quick_reference_all</i>
                                    <span key="t-chat">Lookups</span>
                                </a>
                                <ul className={menuActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                    <li onClick={() => handleMenuClick("/tests")} className={`waves-effect ${isActive('/tests') || isActive('/edittest/' + id) || isActive("/viewtest/" + id)}`}><a key="t-tui-calendar">Tests</a></li>
                                    <li onClick={() => handleMenuClick("/biopsytypes")} className={`waves-effect ${isActive('/biopsytypes') || isActive('/editbiopsytypes/' + id) || isActive('/viewbiopsy/' + id)}`}><a key="t-full-calendar">Biopsy types</a></li>
                                    <li onClick={() => handleMenuClick("/answers")} className={`waves-effect ${isActive('/answers')}`}><a key="t-full-calendar">Answers</a></li>
                                </ul>
                            </li>







                            <li></li>

                            {/* <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">dashboard_2</i>
                                    <span>Modules Management</span>
                                </a>
                            </li> */}


                            <li>
                                <a className={`waves-effect ${isActive('/fellowshiplist')}`} onClick={() => {
                                    handleMenuClick("/fellowshiplist")
                                }}>
                                    <i className="material-symbols-outlined">assignment</i>
                                    <span>Fellowship</span>
                                </a>
                            </li>
                            <li>
                                <a className={`waves-effect ${isActive('/transctions')}`} onClick={() => {
                                    handleMenuClick("/transctions")
                                }}>
                                    <i className="material-symbols-outlined">receipt_long</i>
                                    <span>Transactions</span>
                                </a>
                            </li>
                            <li onClick={() => handleMenuClick("/registeredusers")}>
                                <a className={`waves-effect ${isActive('/registeredusers')}`}>
                                    <i className="material-symbols-outlined">group</i>
                                    <span>Registered Users</span>
                                </a>
                            </li>
                            <li onClick={() => handleMenuClick("/users")}>
                                <a className={`waves-effect ${isActive('/users')}`}>
                                    <i className="material-symbols-outlined">account_box</i>
                                    <span>Users</span>
                                </a>
                            </li>

                            <li>
                                <a onClick={(e) => {
                                    setMenuLearning(false);
                                    setMenuState(false);
                                    setMenuSettings(!menuSettingsActive);
                                }} className="has-arrow waves-effect">
                                    <i className="material-symbols-outlined"> settings</i>
                                    <span key="t-chat">Settings</span>
                                </a>
                                <ul className={menuSettingsActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                    <li onClick={() => handleMenuClick("/subscriptionplans")} className={`waves-effect ${isActive('/subscriptionplans')}`}><a key="t-tui-calendar">Subscriptions</a></li>
                                    {/* <li>
                                <a className={`waves-effect ${isActive('/subscription')}`} onClick={() => {
                                    handleMenuClick("/subscriptionplans")
                                }}>
                                    <i className="material-symbols-outlined">subscriptions</i>
                                    <span>Subscription</span>
                                </a>
                            </li> */}
                                    {/* <li onClick={() => handleMenuClick("/biopsytypes")} className={`waves-effect ${isActive('/biopsytypes') || isActive('/editbiopsytypes/' + id) || isActive('/viewbiopsy/' + id)}`}><a key="t-full-calendar">Biopsy types</a></li>
                                    <li onClick={() => handleMenuClick("/answers")} className={`waves-effect ${isActive('/answers')}`}><a key="t-full-calendar">Answers</a></li> */}
                                </ul>
                            </li>

                            {/* <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">payments</i>
                                    <span>Payments</span>
                                </a>
                            </li> */}

                        </ul> : userType?.toLowerCase() === 'lab technician' ?
                            <ul className="metismenu list-unstyled" id="side-menu">
                                <li onClick={() => handleMenuClick("/dashboard")}>
                                    <a className={`waves-effect ${isActive('/dashboard')}`}>
                                        <i className="material-symbols-outlined">grid_view</i>
                                        <span>Biopsy</span>
                                    </a>
                                </li>

                                <li
                                // onClick={() => handleMenuClick("/users")}
                                >
                                    <a className={`waves-effect ${isActive('/users')}`}>
                                        <i className="material-symbols-outlined">account_box</i>
                                        <span>Assigned Cases</span>
                                    </a>
                                </li>


                                <li
                                // onClick={(e) => {
                                //         setMenuLearning(false);
                                //         setMenuState(!menuActive);
                                //     }}
                                >
                                    <a className="has-arrow waves-effect">
                                        <i className="material-symbols-outlined"> quick_reference_all</i>
                                        <span key="t-chat">Additional Test Requests</span>
                                    </a>
                                    {/* <ul className={menuActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                    <li onClick={() => handleMenuClick("/tests")} className={`waves-effect ${isActive('/tests') || isActive('/edittest/' + id) || isActive("/viewtest/" + id)}`}><a key="t-tui-calendar">Tests</a></li>
                                    <li onClick={() => handleMenuClick("/biopsytypes")} className={`waves-effect ${isActive('/biopsytypes') || isActive('/editbiopsytypes/' + id) || isActive('/viewbiopsy/' + id)}`}><a key="t-full-calendar">Biopsy types</a></li>
                                    <li onClick={() => handleMenuClick("/answers")} className={`waves-effect ${isActive('/answers')}`}><a key="t-full-calendar">Answers</a></li>
                                </ul> */}
                                </li>

                                <li
                                // onClick={(e) => {
                                //     setMenuLearning(!menuLearningActive);
                                //     setMenuState(false);
                                // }} 
                                >
                                    <a

                                        className="has-arrow waves-effect">
                                        {/* <i className="material-symbols-outlined"> quick_reference_all</i> */}
                                        <i className="material-symbols-outlined"> library_books</i>
                                        <span key="t-chat">Payment Reports</span>
                                    </a>
                                    {/* <ul className={menuLearningActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                    <li onClick={() => handleMenuClick("/modules")} className={`waves-effect ${isActive('/modules')}`}><a key="t-tui-calendar">Modules</a></li>
                                    <li onClick={() => handleMenuClick("/cases")} className={`waves-effect ${isActive('/cases') || isActive('/editcase/' + id) || isActive('/viewcase/' + id)}`}><a key="t-tui-calendar">Cases</a></li>
                                    <li onClick={() => handleMenuClick("/Adminquiz")} className={`waves-effect ${isActive('/Adminquiz')}`}><a key="t-tui-calendar">Quiz</a></li>
                                    <li onClick={() => handleMenuClick("/lecturelibrary")} className={`waves-effect ${isActive('/lecturelibrary') || isActive("/viewlecturelibrary/" + id) || isActive("/editlecturelibrary/" + id)}`}><a key="t-full-calendar">Video Library</a></li>
                                    <li onClick={() => handleMenuClick("/cpcmanagement")} className={`waves-effect ${isActive('/cpcmanagement')}`}><a key="t-full-calendar">CPC Management</a></li>

                                </ul> */}
                                </li>

                                <li></li>
                                {/* 
                            <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">dashboard_2</i>
                                    <span>Modules Management</span>
                                </a>
                            </li>
                            <li>
                                <a className={`waves-effect ${isActive('/subscription')}`} onClick={() => {
                                    navigate("/subscription");
                                }}>
                                    <i className="material-symbols-outlined">subscriptions</i>
                                    <span>Subscription</span>
                                </a>
                            </li>
                            <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">payments</i>
                                    <span>Payments</span>
                                </a>
                            </li> */}

                            </ul> : userType?.toLowerCase() === 'teaching admin' ?
                                <ul className="metismenu list-unstyled" id="side-menu">
                                    <li onClick={() => handleMenuClick("/dashboard")}>
                                        <a className={`waves-effect ${isActive('/dashboard')}`}>
                                            <i className="material-symbols-outlined">grid_view</i>
                                            <span>Biopsy</span>
                                        </a>
                                    </li>

                                    <li
                                    // onClick={() => handleMenuClick("/users")}
                                    >
                                        <a className={`waves-effect ${isActive('/users')}`}>
                                            <i className="material-symbols-outlined">account_box</i>
                                            <span>Review Teaching Cases</span>
                                        </a>
                                    </li>


                                    <li
                                    // onClick={(e) => {
                                    //         setMenuLearning(false);
                                    //         setMenuState(!menuActive);
                                    //     }}
                                    >
                                        <a className="has-arrow waves-effect">
                                            <i className="material-symbols-outlined"> quick_reference_all</i>
                                            <span key="t-chat">Slide Library</span>
                                        </a>
                                        {/* <ul className={menuActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                    <li onClick={() => handleMenuClick("/tests")} className={`waves-effect ${isActive('/tests') || isActive('/edittest/' + id) || isActive("/viewtest/" + id)}`}><a key="t-tui-calendar">Tests</a></li>
                                    <li onClick={() => handleMenuClick("/biopsytypes")} className={`waves-effect ${isActive('/biopsytypes') || isActive('/editbiopsytypes/' + id) || isActive('/viewbiopsy/' + id)}`}><a key="t-full-calendar">Biopsy types</a></li>
                                    <li onClick={() => handleMenuClick("/answers")} className={`waves-effect ${isActive('/answers')}`}><a key="t-full-calendar">Answers</a></li>
                                </ul> */}
                                    </li>

                                    <li
                                    // onClick={(e) => {
                                    //     setMenuLearning(!menuLearningActive);
                                    //     setMenuState(false);
                                    // }} 
                                    >
                                        <a

                                            className="has-arrow waves-effect">
                                            {/* <i className="material-symbols-outlined"> quick_reference_all</i> */}
                                            <i className="material-symbols-outlined"> library_books</i>
                                            <span key="t-chat">Module Management</span>
                                        </a>
                                        {/* <ul className={menuLearningActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                    <li onClick={() => handleMenuClick("/modules")} className={`waves-effect ${isActive('/modules')}`}><a key="t-tui-calendar">Modules</a></li>
                                    <li onClick={() => handleMenuClick("/cases")} className={`waves-effect ${isActive('/cases') || isActive('/editcase/' + id) || isActive('/viewcase/' + id)}`}><a key="t-tui-calendar">Cases</a></li>
                                    <li onClick={() => handleMenuClick("/Adminquiz")} className={`waves-effect ${isActive('/Adminquiz')}`}><a key="t-tui-calendar">Quiz</a></li>
                                    <li onClick={() => handleMenuClick("/lecturelibrary")} className={`waves-effect ${isActive('/lecturelibrary') || isActive("/viewlecturelibrary/" + id) || isActive("/editlecturelibrary/" + id)}`}><a key="t-full-calendar">Video Library</a></li>
                                    <li onClick={() => handleMenuClick("/cpcmanagement")} className={`waves-effect ${isActive('/cpcmanagement')}`}><a key="t-full-calendar">CPC Management</a></li>

                                </ul> */}
                                    </li>

                                    <li
                                    // onClick={() => handleMenuClick("/users")}
                                    >
                                        <a className={`waves-effect ${isActive('/users')}`}>
                                            <i className="material-symbols-outlined">account_box</i>
                                            <span>CPC Scheduling</span>
                                        </a>
                                    </li>
                                    <li
                                    // onClick={() => handleMenuClick("/users")}
                                    >
                                        <a className={`waves-effect ${isActive('/users')}`}>
                                            <i className="material-symbols-outlined">account_box</i>
                                            <span>Fellowship Management</span>
                                        </a>
                                    </li>


                                    {/* 
                            <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">dashboard_2</i>
                                    <span>Modules Management</span>
                                </a>
                            </li>
                            <li>
                                <a className={`waves-effect ${isActive('/subscription')}`} onClick={() => {
                                    navigate("/subscription");
                                }}>
                                    <i className="material-symbols-outlined">subscriptions</i>
                                    <span>Subscription</span>
                                </a>
                            </li>
                            <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">payments</i>
                                    <span>Payments</span>
                                </a>
                            </li> */}

                                </ul> : userType?.toLowerCase() === 'pathologist' ?
                                    <ul className="metismenu list-unstyled" id="side-menu">
                                        <li onClick={() => handleMenuClick("/dashboard")}>
                                            <a className={`waves-effect ${isActive('/dashboard')}`}>
                                                <i className="material-symbols-outlined">grid_view</i>
                                                <span>Biopsy</span>
                                            </a>
                                        </li>
                                        <li onClick={() => handleMenuClick("/fellows")}>
                                            <a className={`waves-effect ${isActive('/fellows')}`}>
                                                <i className="material-symbols-outlined">grid_view</i>
                                                <span>Fellows</span>
                                            </a>
                                        </li>
                                        {/* <li 
                            
                            >
                                <a className={`waves-effect ${isActive('/users')}`}>
                                    <i className="material-symbols-outlined">account_box</i>
                                    <span>Assigned Cases</span>
                                </a>
                            </li>


                            <li  
                           
                                >
                                <a  className="has-arrow waves-effect">
                                    <i className="material-symbols-outlined"> quick_reference_all</i>
                                    <span key="t-chat">Additional Test Requests</span>
                                </a>
                              
                            </li>

                            <li
                            
                            >
                                <a 
                               
                                className="has-arrow waves-effect">
                                   
                                    <i className="material-symbols-outlined"> library_books</i>
                                    <span key="t-chat">Payment Reports</span>
                                </a>
                                
                            </li> */}

                                        <li></li>
                                        {/* 
                            <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">dashboard_2</i>
                                    <span>Modules Management</span>
                                </a>
                            </li>
                            <li>
                                <a className={`waves-effect ${isActive('/subscription')}`} onClick={() => {
                                    navigate("/subscription");
                                }}>
                                    <i className="material-symbols-outlined">subscriptions</i>
                                    <span>Subscription</span>
                                </a>
                            </li>
                            <li>
                                <a className={`waves-effect ${isActive('/reports')}`}>
                                    <i className="material-symbols-outlined">payments</i>
                                    <span>Payments</span>
                                </a>
                            </li> */}

                                    </ul> : userType?.toLowerCase() === "doctor" ?
                                        <ul className="metismenu list-unstyled" id="side-menu">
                                            <li>
                                                <a onClick={() => handleMenuClick("/cpc")} className={`waves-effect ${isActive('/cpc')}`}>
                                                    <i className="material-symbols-outlined"> video_library </i>
                                                    <span key="t-dashboards">CPC </span>
                                                </a>

                                            </li>


                                            <li>
                                                <a onClick={() => handleMenuClick("/lecture-library")} className={`waves-effect ${isActive('/lecture-library')}`}>
                                                    <i className="material-symbols-outlined"> category </i>
                                                    <span key="t-layouts">Video Library</span>
                                                </a>

                                            </li>

                                            <li>
                                                {/* <a  onClick={() => handleMenuClick("/moduleslibrary")}    className={`waves-effect ${isActive('/moduleslibrary')}`}>
                            <i className="material-symbols-outlined"> category </i>
                            <span key="t-layouts">Learning Module</span>
                        </a> */}
                                                <a onClick={(e) => {
                                                    setMenuLearning(false);
                                                    setMenuState(!menuActive);

                                                }} className="has-arrow waves-effect">
                                                    <i className="material-symbols-outlined"> category</i>
                                                    <span key="t-chat">Learning Module</span>
                                                </a>
                                                <ul className={menuActive ? "sub-menu mm-collapse mm-show" : "sub-menu mm-collapse"} aria-expanded="false">
                                                    <li onClick={() => handleMenuClick("/moduleslibrary", "allModules")} className={`waves-effect ${isActive("/moduleslibrary", "allModules")}`}><a key="t-tui-calendar">All Modules</a></li>

                                                    <li onClick={() => handleMenuClick("/usermoduleslibrary", "myModules")} className={`waves-effect ${isActive("/usermoduleslibrary", "myModules")}`}><a key="t-full-calendar">My Modules</a></li>
                                                    <li onClick={() => handleMenuClick("/fellowshipmodules", "fellowshipModules")} className={`waves-effect ${isActive("/fellowshipmodules", "fellowshipModules")}`}><a key="t-full-calendar">Fellowship Modules</a></li>

                                                    {/* {userData?.subscriptionplanid && <li onClick={() => handleMenuClick("/fellowshipmodules")} className={`waves-effect ${isActive('/fellowshipmodules' || '/result/' + id)}`}><a key="t-full-calendar">Fellowship Modules</a></li>} */}

                                                    {/* <li onClick={() => handleMenuClick("/answers")} className={`waves-effect ${isActive('/answers')}`}><a key="t-full-calendar">Answers</a></li> */}
                                                </ul>
                                            </li>
                                            <li onClick={() => handleMenuClick("/biopsy")}>
                                                <a className={`waves-effect ${isActive('/biopsy') || isActive('/editbiopsycase/' + id) || isActive('/viewbiopsycase/' + id)}`}>
                                                    <i className="material-symbols-outlined">grid_view</i>
                                                    <span>Biopsy</span>
                                                </a>
                                            </li>
                                            <li onClick={() => handleMenuClick("/transactiondata")}>
                                                <a className={`waves-effect ${isActive('/transactiondata') }`}>
                                                    <i className="material-symbols-outlined">grid_view</i>
                                                    <span>Transactions</span>
                                                </a>
                                            </li>
                                        </ul> : ""}


                </div>
                <p className="activity_time">Action: {localStorage.getItem("timeActivity")}</p>
            </div>
        </div>
    );
};

export default Sidebar;
